const mutations={
    login(state,user){
        state.userInfo=user;
    }
}

export default mutations;